
      import { api } from './src/api.js';

      function fmt(n) { return typeof n === 'number' ? n.toLocaleString() : n; }

      // Model cases
      const cases = await api.modelCases();
      const casesEl = document.getElementById('cases-list');
      casesEl.innerHTML = cases.items.map(c => {
        const p = c.payload || {};
        const prop = p.proposal || {};
        const econ = p.economics || {};
        return `<div class="card">
          <div class="meta"><span class="badge">${c.segment}</span>${c.code}</div>
          <div class="label">${c.label}</div>
          <div class="stats">
            <div class="stat"><div class="stat-label">PV容量</div><div class="stat-value">${prop.pv_kw || '-'} kW</div></div>
            <div class="stat"><div class="stat-label">蓄電池</div><div class="stat-value">${prop.battery_kwh || 0} kWh</div></div>
            <div class="stat"><div class="stat-label">回収年数</div><div class="stat-value">${econ.payback_years || '-'} 年</div></div>
            <div class="stat"><div class="stat-label">初期費用</div><div class="stat-value">¥${fmt(econ.initial_cost_jpy || 0)}</div></div>
            <div class="stat"><div class="stat-label">補助金</div><div class="stat-value">¥${fmt(econ.subsidy_jpy || 0)}</div></div>
            <div class="stat"><div class="stat-label">年間節約</div><div class="stat-value">¥${fmt(econ.annual_saving_jpy || 0)}</div></div>
          </div>
        </div>`;
      }).join('');

      // Subsidies
      const allSubs = await api.subsidies();
      const subsRegions = [...new Set(allSubs.items.map(s => s.region).filter(Boolean))].sort();
      const regionSel = document.getElementById('subsidy-region');
      for (const r of subsRegions) {
        const opt = document.createElement('option');
        opt.value = r; opt.textContent = r;
        regionSel.appendChild(opt);
      }
      document.getElementById('subsidies-meta').textContent =
        `合計 ${allSubs.total} 件 / 最新キャッシュ更新: ${allSubs.meta?.fetched_at || '-'} / マスター更新: ${allSubs.meta?.updated_at || '-'}`;

      function renderSubs() {
        const cat = document.getElementById('subsidy-category').value;
        const reg = document.getElementById('subsidy-region').value;
        const sta = document.getElementById('subsidy-status').value;
        let items = allSubs.items;
        if (cat) items = items.filter(i => i.category === cat);
        if (reg) items = items.filter(i => i.region === reg);
        if (sta) items = items.filter(i => i.status === sta);
        const STATUS_LABEL = { upcoming: '公募予定', active: '公募中', closed: '受付終了' };
        document.getElementById('subsidies-list').innerHTML = items.map(it => `
          <div class="card">
            <div class="meta">
              <span class="badge">${it.category || '-'}</span>
              <span class="badge" style="background:#475569;color:#fff;">${it.region || '-'}</span>
              <span class="badge" style="background:${it.status === 'closed' ? '#94a3b8' : it.status === 'active' ? '#22c55e' : '#fbbf24'};color:#0f172a;">${STATUS_LABEL[it.status] || it.status || '-'}</span>
              ${it.id}
            </div>
            <div class="label">${it.name}</div>
            <div class="stats">
              <div class="stat"><div class="stat-label">補助率</div><div class="stat-value">${it.rate ? it.rate + '%' : '-'}</div></div>
              <div class="stat"><div class="stat-label">単価上限</div><div class="stat-value">${it.unit_cap_jpy ? '¥' + fmt(it.unit_cap_jpy) + '/' + (it.unit_cap_unit || '') : '-'}</div></div>
              <div class="stat"><div class="stat-label">予算上限</div><div class="stat-value">${it.total_cap_jpy ? '¥' + fmt(it.total_cap_jpy) : '-'}</div></div>
            </div>
            <table>
              <tr><th style="width:6em;">所管</th><td>${it.authority || '-'}</td></tr>
              <tr><th>公募期間</th><td>${it.period_start || '?'} 〜 ${it.period_end || '?'}</td></tr>
              <tr><th>条件</th><td>${it.conditions || '-'}</td></tr>
              <tr><th>出典</th><td>${it.source_url ? `<a href="${it.source_url}" target="_blank" rel="noopener" style="color:var(--accent);word-break:break-all;">${it.source_url}</a>` : '-'}</td></tr>
            </table>
          </div>
        `).join('');
      }
      renderSubs();
      ['subsidy-category', 'subsidy-region', 'subsidy-status'].forEach(id =>
        document.getElementById(id).addEventListener('change', renderSubs)
      );

      // Power plans (with company filter)
      const allPlans = await api.powerPlans();
      const companyFilter = document.getElementById('company-filter');
      const plansEl = document.getElementById('plans-list');

      const companies = new Map();
      for (const p of allPlans.items) {
        if (!companies.has(p.company.code)) companies.set(p.company.code, p.company.name);
      }
      for (const [code, name] of companies) {
        const opt = document.createElement('option');
        opt.value = code; opt.textContent = name;
        companyFilter.appendChild(opt);
      }

      function renderPlans(filter) {
        const items = filter ? allPlans.items.filter(p => p.company.code === filter) : allPlans.items;
        const byCompany = new Map();
        for (const p of items) {
          const key = p.company.code;
          if (!byCompany.has(key)) byCompany.set(key, { name: p.company.name, region: p.company.region, plans: [] });
          byCompany.get(key).plans.push(p);
        }
        plansEl.innerHTML = [...byCompany.entries()].map(([code, c]) => `
          <div class="card">
            <div class="meta"><span class="badge">${c.region}</span>${code}</div>
            <div class="label">${c.name}</div>
            <table>
              <thead><tr><th>プラン</th><th>カテゴリ</th><th>説明</th></tr></thead>
              <tbody>${c.plans.map(p => `<tr><td>${p.name}</td><td>${p.category}</td><td>${p.description || ''}</td></tr>`).join('')}</tbody>
            </table>
          </div>
        `).join('');
      }
      renderPlans('');
      companyFilter.addEventListener('change', e => renderPlans(e.target.value));
    